import React, { Fragment, useEffect } from "react";
import { clearStoreDetail, fetchStoreList } from "../actions/store";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const StoreList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "stores";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { storeList } = useSelector((state) => state.storeReducer);

  useEffect(() => {
    dispatch(fetchStoreList());
    dispatch(clearStoreDetail());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id) return null;
    return (
      <ButtonColumn editLink={`/store-edit/` + params.data.id} value={params} />
    );
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("storeList.companyCountry"),
      field: "companyCountryName",
      filter: "agSetColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: t("storeList.company"),
      field: "companyName",
      filter: "agSetColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: t("storeList.storeName"),
      field: "name",
      filter: "agTextColumnFilter",
      minWidth: 250,
      flex: 1,
    },

    {
      headerName: t("storeList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return t("storeList.inactive");
          case "ACTIVE":
            return t("storeList.active");
          default:
            return "";
        }
      },
      width: 150,
    },
    {
      headerName: t("storeList.contactEmail"),
      field: "email",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("storeList.contactPhone"),
      field: "phone",
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("storeList.address"),
      field: "address",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 80,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={storeList}
        columnDefs={columnDefs}
        buttonLink={`/store-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"store-list"}
      />
    </Fragment>
  );
};

export default StoreList;
